export class BrowserFeatureCheckUtil {
  private static _instance: BrowserFeatureCheckUtil;

  static get instance(): BrowserFeatureCheckUtil {
    if (!BrowserFeatureCheckUtil._instance) {
      BrowserFeatureCheckUtil._instance = new BrowserFeatureCheckUtil();
    }
    return BrowserFeatureCheckUtil._instance;
  }

  supportsSpeechRecognition(): boolean {
    return 'SpeechRecognition' in window || 'webkitSpeechRecognition' in window;
  }
}

export const getBrowserFeatureCheckUtil = (): BrowserFeatureCheckUtil => BrowserFeatureCheckUtil.instance;
